'use client';
import { jsx } from 'react/jsx-runtime';
import { useSwitchStyles, useSwitchContext } from './switch-context.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const SwitchLabel = forwardRef(
  function SwitchLabel2(props, ref) {
    const styles = useSwitchStyles();
    const api = useSwitchContext();
    return /* @__PURE__ */ jsx(
      chakra.span,
      {
        className: "chakra-switch__label",
        ...api.getLabelProps(props, ref),
        __css: styles.label
      }
    );
  }
);
SwitchLabel.displayName = "SwitchLabel";

export { SwitchLabel };
